import { planUtils } from 'utils/plan/plan.utils';

export const isSubscriptionLegacyPlan = (plan: Plan) => {
  const isFreePlan = planUtils.getIsFree(plan);
  const isEssentialPlan = planUtils.getType(plan) === 'essential';

  return plan?.max_bdbs > 1 && isEssentialPlan && !isFreePlan;
};
